import React, { useState } from "react";
import Tabs from "./Tabs";

const TabComponent = (props) => {
   const { openMod } = props;
  const [activeTabID, setActiveTabID] = useState(0);

  const onClickTab = (tab) => {
    setActiveTabID(tab);
  };

  // function InfiniteScroll() {
  //   if (activeTabID >= 3) {
  //     setActiveTabID(0);
  //     return;
  //   }
  //   setActiveTabID(activeTabID + 1);
  // }

  // setInterval(InfiniteScroll, 100000);

  return (
    <div>
      <Tabs openMod={openMod} activeTabID={activeTabID} onClickTab={onClickTab} />
    </div>
  );
};

export default TabComponent;
